// React Component
import React, { useState } from 'react'

// App Component
import CampaignNavLayout from '../../layouts/CampaignNavLayout'
import HeaderInterview from '../interview/header'
import CampaignChatbot from './components/campaignChatbot'
import { Tutorial, FloatingTutorialButton } from '../../components'

// Features
import { useTranslation } from 'react-i18next'
import { useTutorial } from '../../hooks/useTutorial'
import { campaignsTutorialSteps } from '../../config/tutorialSteps'

//interface
import CampaignStatus from './components/CampaignStatus'
import MainView from './components/MainView'


const CampaignsView = () => {
    const { t } = useTranslation();
    const [rightSidebarCollapsed, setRightSidebarCollapsed] = useState(false);

    const [mainView, setMainView] = useState('aiAssistant');

    const [displayedCampaign, setDisplayedCampaign] = useState<string | undefined>(undefined);

    // Tutorial setup
    const tutorialSteps = campaignsTutorialSteps(t);
    const {
        run: runTutorial,
        stepIndex,
        steps,
        startTutorial,
        handleJoyrideCallback,
        isTutorialCompleted,
        resetTutorialProgress
    } = useTutorial(tutorialSteps, 'campaigns', true); // Auto-start for new users


    return (
        <>
            <div className="d-flex justify-content-between fixed-top h-full newbg-black vw-100 tutorial-campaigns-welcome">
                <div className="m-none h-100" style={{ backgroundColor: "#1F1F21", width: "285px" }} data-tutorial="campaign-navigation">
                    <CampaignNavLayout
                        updateDisplayedCampaign={(campaignId: string) => setDisplayedCampaign(campaignId)}
                    />
                </div>

                <div
                    className="container px-0 px-md-5 vh-100 newbg-black"
                    style={{
                        marginRight: rightSidebarCollapsed ? '4rem' : '20rem',
                        transition: 'margin-right 0.3s ease',
                        width: `calc(100% - 285px - ${rightSidebarCollapsed ? '4rem' : '20rem'})`
                    }}
                    data-tutorial="campaign-main-view"
                >
                    <HeaderInterview />
                    {mainView === 'aiAssistant' && (
                        <div data-tutorial="ai-assistant">
                            <CampaignChatbot
                                campaignId={displayedCampaign}
                                stepName="Define_objectives"
                            />
                        </div>
                    )}
                    {mainView === 'processes' && (
                        <div className="d-flex align-items-center justify-content-center h-100">
                            <div className="text-center text-light">
                                <i className="bi bi-diagram-3 fs-1 mb-3"></i>
                                <h4>{t('campaigns.manageProcesses')}</h4>
                                <p className="text-secondary">{t('campaigns.comingSoon')}</p>
                            </div>
                        </div>
                    )}
                    {mainView === 'collaborators' && (
                        <div className="d-flex align-items-center justify-content-center h-100">
                            <div className="text-center text-light">
                                <i className="bi bi-people fs-1 mb-3"></i>
                                <h4>{t('campaigns.manageCollaborators')}</h4>
                                <p className="text-secondary">{t('campaigns.comingSoon')}</p>
                            </div>
                        </div>
                    )}
                    {mainView === 'report' && (
                        <div className="d-flex align-items-center justify-content-center h-100">
                            <div className="text-center text-light">
                                <i className="bi bi-file-earmark-text fs-1 mb-3"></i>
                                <h4>{t('campaigns.report')}</h4>
                                <p className="text-secondary">{t('campaigns.comingSoon')}</p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Sidebar Droite - Checklist et Actions Rapides */}
                <aside
                    className="position-fixed top-0 end-0 h-100 d-flex flex-column"
                    style={{
                        width: rightSidebarCollapsed ? '4rem' : '20rem',
                        backgroundColor: '#1F1F21',
                        zIndex: 999,
                        borderLeft: '1px solid rgba(255,255,255,0.1)',
                        boxShadow: '-2px 0 8px rgba(0,0,0,0.3)',
                        transition: 'width 0.3s ease'
                    }}
                    data-tutorial="campaign-sidebar"
                >

                    <div className="overflow-auto p-3 flex flex-column">
                        {/* Bouton de réduction - Positionné en haut */}
                        <button
                            onClick={() => setRightSidebarCollapsed(!rightSidebarCollapsed)}
                            className="btn btn-link text-light p-0 border-0 mb-2 self-end w-[24px]"
                            style={{ alignSelf: 'end' }}
                        >
                            <i className={rightSidebarCollapsed ? "bi bi-chevron-left" : "bi bi-x-lg"}></i>
                        </button>
                        {!rightSidebarCollapsed && (
                            displayedCampaign ? (
                                <>
                                    <div data-tutorial="campaign-status">
                                        <CampaignStatus campaignId={displayedCampaign} />
                                    </div>
                                    <div data-tutorial="main-view-tabs">
                                        <MainView changeView={setMainView} currentView={mainView}/>
                                    </div>
                                </>
                            ) : (
                                <div className="text-center text-light">
                                    <i className="bi bi-exclamation-circle fs-1 mb-3"></i>
                                    <h4>{t('campaigns.needToSelectACampaign')}</h4>
                                </div>
                            )
                        )
                        }
                    </div>
                </aside>
            </div>

            {/* Tutorial Component */}
            <Tutorial
                run={runTutorial}
                steps={steps}
                stepIndex={stepIndex}
                callback={handleJoyrideCallback}
                continuous={true}
                showProgress={true}
                showSkipButton={true}
            />

            {/* Floating Tutorial Button */}
            <FloatingTutorialButton onClick={startTutorial} />
        </>
    )
}

export default CampaignsView
